import tagReducer from './';

export default tagReducer;
